export type DayKey = "sat" | "sun" | "mon" | "tue" | "wed" | "thu" | "fri";

export interface DaySchedule {
  enabled: boolean;
  open: string;
  close: string;
}

export type PickupMethodKey = "dine_in" | "takeaway" | "car";

export type PickupMethods = Record<PickupMethodKey, boolean>;

export interface BranchSettings {
  contactPhone: string;
  workingHours: Record<DayKey, DaySchedule>;
  emergencyClosure: {
    active: boolean;
    reason: string;
  };
  pickupPolicy: {
    methods: PickupMethods;
    estimatedMinutes: number;
    payOnPickup: boolean;
  };
  /** خدمة التوصيل بواسطة المحل — تُدار من لوحة المحل التجاري (للعرض فقط في لوحة الفرع) */
  delivery: {
    enabled: boolean;
    fee: number;
  };
}

export const defaultBranchSettings: BranchSettings = {
  contactPhone: "0112345678",
  workingHours: {
    sat: { enabled: true, open: "10:00", close: "23:00" },
    sun: { enabled: true, open: "10:00", close: "23:00" },
    mon: { enabled: true, open: "10:00", close: "23:00" },
    tue: { enabled: true, open: "10:00", close: "23:00" },
    wed: { enabled: true, open: "10:00", close: "23:00" },
    thu: { enabled: true, open: "10:00", close: "23:00" },
    fri: { enabled: true, open: "14:00", close: "23:00" },
  },
  emergencyClosure: {
    active: false,
    reason: "",
  },
  pickupPolicy: {
    methods: { dine_in: true, takeaway: true, car: true },
    estimatedMinutes: 20,
    payOnPickup: true,
  },
  delivery: {
    enabled: true,
    fee: 15,
  },
};